export default function SeoScript() {
  const siteUrl = import.meta.env.VITE_SITE_URL || "";

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    "name": "주식회사 프라임파트너스",
    "alternateName": "Prime Partners",
    "description": "프라임파트너스는 시장 분석을 기반으로 회원 맞춤형 투자 정보를 제공하는 유사투자자문 전문기업입니다. 데일리 마켓 브리핑, 종목 심층 분석, 실시간 투자 시그널까지.",
    "url": siteUrl,
    "telephone": "+82-70-7008-0070",
    "email": "primepartners@naver.com",
    "foundingDate": "2008",
    "founder": {
      "@type": "Person",
      "name": "도관인"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "세석로20 폴리프라자1 10층",
      "addressLocality": "의정부시",
      "addressRegion": "경기도",
      "postalCode": "11827",
      "addressCountry": "KR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "37.737198",
      "longitude": "127.119426"
    },
    "image": siteUrl ? `${siteUrl}/logo.png` : "https://static.readdy.ai/image/f943031b43fc8da94030f1522c0523e1/6ec30ea469d650b6685d8f11bd18e554.png",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }
    ],
    "priceRange": "상담문의",
    "areaServed": {
      "@type": "Country",
      "name": "대한민국"
    }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "프라임파트너스 | 시장을 읽는 힘, 투자의 기준을 제시합니다",
    "description": "프라임파트너스는 시장 분석을 기반으로 회원 맞춤형 투자 정보를 제공하는 유사투자자문 전문기업입니다. 데일리 마켓 브리핑, 종목 심층 분석, 실시간 투자 시그널까지.",
    "url": siteUrl,
    "inLanguage": "ko-KR",
    "about": {
      "@type": "FinancialService",
      "name": "주식회사 프라임파트너스"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "프라임파트너스는 어떤 서비스를 제공하나요?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "프라임파트너스는 시장 브리핑, 종목 분석, VIP 컨설팅 세 가지 핵심 서비스를 제공합니다. 매일 아침 국내 증시 핵심 이슈 분석, 멀티팩터 기반 종목 심층 분석, 전담 애널리스트 1:1 맞춤 컨설팅을 통해 회원님의 투자 판단을 돕습니다."
        }
      },
      {
        "@type": "Question",
        "name": "유사투자자문업이란 무엇인가요?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "유사투자자문업은 금융투자업자가 아닌 자로서 투자 판단에 관한 정보를 제공하는 서비스입니다. 프라임파트너스는 정식 등록된 유사투자자문업체로, 개별 투자상담과 자금운용이 아닌 투자 정보 제공에 특화되어 있습니다."
        }
      },
      {
        "@type": "Question",
        "name": "상담 신청 후 어떻게 진행되나요?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "상담 신청서를 제출하시면 전담 애널리스트가 영업일 기준 1일 이내에 기재하신 연락처로 연락드립니다. 초기 무료 상담을 통해 회원님의 투자 성향과 현재 상황을 파악한 후, 맞춤형 서비스 이용 여부를 결정하실 수 있습니다."
        }
      },
      {
        "@type": "Question",
        "name": "투자 손실에 대한 책임은 어떻게 되나요?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "프라임파트너스가 제공하는 모든 정보는 투자 판단에 대한 참고자료이며, 투자의 최종 책임은 투자자 본인에게 있습니다. 금융상품의 가치는 시장 상황에 따라 변동될 수 있으며 원금 손실이 발생할 수 있습니다. 과거의 수익률은 미래의 수익을 보장하지 않습니다."
        }
      }
    ]
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}